import { ref } from "vue";

const avatarSeed = ref(null);
const avatarStyle = ref(null);
const isLoading = ref(false);

// 可用的头像风格列表
const AVATAR_STYLES = [
  "adventurer",
  "adventurer-neutral",
  "avataaars",
  "avataaars-neutral",
  "big-ears",
  "big-ears-neutral",
  "big-smile",
  "bottts",
  "bottts-neutral",
  "croodles",
  "croodles-neutral",
  "dylan",
  "fun-emoji",
  "glass",
  "icons",
  "identicon",
  "initials",
  "lorelei",
  "lorelei-neutral",
  "micah",
  "miniavs",
  "notionists",
  "notionists-neutral",
  "open-peeps",
  "personas",
  "pixel-art",
  "pixel-art-neutral",
  "rings",
  "shapes",
  "thumbs",
];

export const useUserInfo = () => {
  // 生成新的头像
  const generateNewAvatar = async () => {
    isLoading.value = true;
    try {
      const newSeed = "easylink-" + Math.random().toString(36).substr(2, 9);
      const newStyle =
        AVATAR_STYLES[Math.floor(Math.random() * AVATAR_STYLES.length)];

      // 预加载新头像
      await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = `https://api.dicebear.com/9.x/${newStyle}/svg?seed=${newSeed}&backgroundColor=79CA9E`;
      });

      // 头像加载成功后再更新状态
      avatarSeed.value = newSeed;
      avatarStyle.value = newStyle;

      localStorage.setItem("avatarSeed", newSeed);
      localStorage.setItem("avatarStyle", newStyle);
    } catch (error) {
      console.error("Failed to load new avatar:", error);
    } finally {
      isLoading.value = false;
    }
  };

  // 获取当前头像URL
  const getAvatarUrl = () => {
    if (!avatarSeed.value || !avatarStyle.value) {
      const savedSeed = localStorage.getItem("avatarSeed");
      const savedStyle = localStorage.getItem("avatarStyle");
      if (savedSeed && savedStyle) {
        avatarSeed.value = savedSeed;
        avatarStyle.value = savedStyle;
      } else {
        generateNewAvatar();
      }
    }
    return `https://api.dicebear.com/9.x/${avatarStyle.value}/svg?seed=${avatarSeed.value}&backgroundColor=79CA9E`;
  };

  return {
    state: {
      avatarSeed,
      avatarStyle,
      isLoading,
    },
    action: {
      generateNewAvatar,
      getAvatarUrl,
    },
  };
};
